import React from "react";
import { Link } from "react-router-dom";
import { Phone, MessageCircle, FileText } from "lucide-react";
import { waLink } from "@/config/site";
import { useSettings } from "@/context/SettingsContext";

// Fixed bottom actions for mobile. Reserves space via a spacer so it never covers content.
export default function MobileStickyBar() {
  const { contact } = useSettings();
  return (
    <>
      <div className="h-[64px] lg:hidden" aria-hidden="true" />
      <div
        className="fixed bottom-0 inset-x-0 z-40 lg:hidden bg-white border-t border-[#D9E0E4] grid grid-cols-3 shadow-[0_-4px_16px_rgba(9,36,61,0.08)]"
        data-testid="mobile-sticky-bar"
      >
        <a
          href={contact.phoneHref}
          className="flex flex-col items-center justify-center gap-0.5 py-2.5 text-navy active:bg-[#EAF1F4]"
          data-testid="sticky-call"
        >
          <Phone className="h-5 w-5" />
          <span className="text-[11px] font-medium">Call</span>
        </a>
        <a
          href={waLink(undefined, contact.whatsappNumber)}
          target="_blank"
          rel="noopener noreferrer"
          className="flex flex-col items-center justify-center gap-0.5 py-2.5 text-navy border-x border-[#D9E0E4] active:bg-[#EAF1F4]"
          data-testid="sticky-whatsapp"
        >
          <MessageCircle className="h-5 w-5" />
          <span className="text-[11px] font-medium">WhatsApp</span>
        </a>
        <Link
          to="/request-a-quote"
          className="flex flex-col items-center justify-center gap-0.5 py-2.5 bg-teal text-white active:bg-[#075652]"
          data-testid="sticky-quote"
        >
          <FileText className="h-5 w-5" />
          <span className="text-[11px] font-semibold">Get quote</span>
        </Link>
      </div>
    </>
  );
}
